import { Box, Typography, ToggleButton } from '@mui/material'
import { styled } from '@mui/styles'

export const CardContainer = styled(Box)({
  height: '100%',
  width: '100%'
})

export const HeaderContainer = styled(Box)(({ isParent }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: isParent ? 20 : 16,
  alignItems: 'center'
}))

export const DeviceTitle = styled(Typography)({
  fontSize: 14,
  fontWeight: 600,
  color: 'content.primary',
  textAlign: 'center'
})

export const StyledToggleButton = styled(ToggleButton)({
  flex: 1,
  height: '32px',
  fontSize: '12px',
  fontWeight: 500,
  textTransform: 'none',
  border: 'none',
  color: 'content.secondary',
  backgroundColor: 'transparent',
  borderRadius: 0,
  zIndex: 1,
  position: 'relative',
  boxSizing: 'border-box',
  transition: 'color 0.2s',
  '&.Mui-selected': {
    color: 'primary.main',
    border: 'none',
    zIndex: 2,
    backgroundColor: 'transparent',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: -2,
      left: -2,
      right: -2,
      bottom: -2,
      border: '2px solid #2570EB',
      borderRadius: '6px',
      pointerEvents: 'none',
      zIndex: 3,
    },
    '&:hover': {
      backgroundColor: 'rgba(37, 112, 235, 0.04)',
    }
  },
  '&:hover': {
    backgroundColor: 'rgba(37, 112, 235, 0.04)',
  }
})

export const ChildrenContainer = styled(Box)({
  height: '520px',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '520px',
  maxHeight: '520px'
})

export const ChildrenTitle = styled(Typography)({
  marginBottom: 16,
  fontSize: 12,
  fontWeight: 300,
  textTransform: 'uppercase',
  color: '#7A8096',
  flexShrink: 0
})

export const ChildrenScrollContainer = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  '&::-webkit-scrollbar-track': {
    display: 'none'
  },
  '&::-webkit-scrollbar-thumb': {
    display: 'none'
  }
})

export const ChildDeviceCard = styled(Box)(({ borderColor, backgroundColor }) => ({
  marginBottom: 16,
  padding: 16,
  border: '1px solid',
  borderColor: borderColor,
  borderRadius: 8,
  backgroundColor: backgroundColor + '20',
  flexShrink: 0
}))

export const DeviceIconContainer = styled(Box)(({ size, backgroundColor, showBackground }) => ({
  width: showBackground ? size + 4 : size,
  height: showBackground ? size + 4 : size,
  borderRadius: showBackground ? '6px' : 0,
  backgroundColor: showBackground ? backgroundColor : 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}))

export const FrequencyContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
})

export const FrequencyRow = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: 4,
  alignItems: 'center'
})

export const FrequencyLabel = styled(Typography)({
  fontWeight: 400,
  fontSize: 12,
  color: '#7A8096'
})

export const FrequencyValue = styled(Typography)({
  fontWeight: 400,
  fontSize: 12,
  color: '#5D5F70'
})

export const SsidContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
})

export const SsidItem = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
})

export const SsidTableWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
})

export const SsidTableHeader = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#F7F7F7',
  borderRadius: 8,
  padding: '6px 10px'
})

export const SsidTableRow = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '5px 10px'
})

export const SsidNameCell = styled(Typography)({
  flex: 1,
  fontSize: 13,
  fontWeight: 400,
  color: '#1A1D23',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
})

export const SsidFreqHeader = styled(Typography)({
  width: 52,
  textAlign: 'center',
  fontSize: 11,
  fontWeight: 500,
  color: '#7A8096',
  flexShrink: 0
})

export const SsidFreqCell = styled(Box)({
  width: 52,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0
})

export const InfoGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 16,
  marginTop: 12
})